import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/user/bo_view_ico.png'
import _imports_1 from '@/assets/user/bo_good_ico.png'
import _imports_2 from '@/assets/user/bo_bad_ico.png'
import _imports_3 from '@/assets/user/bo_comment_ico.png'


const _withScopeId = n => (_pushScopeId("data-v-60405fce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, " 커뮤니티 ", -1))
const _hoisted_5 = { class: "board_wrap" }
const _hoisted_6 = { class: "board_search_box" }
const _hoisted_7 = { class: "list_board" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "120px" })
], -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "impo" }, "공지", -1))
const _hoisted_11 = { class: "date" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "list_info" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "date" }
const _hoisted_19 = {
  key: 1,
  class: "no_list"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "게시글이 없습니다.", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "board_btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_GnbLayout = _resolveComponent("GnbLayout")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderLayout),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "",
                id: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.list.search) = $event)),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchContents && $setup.searchContents(...args)), ["enter"]))
              }, null, 544), [
                [_vModelText, $setup.list.search]
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.searchContents && $setup.searchContents(...args)))
              }, "검색")
            ]),
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              ($setup.list.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list.data, (item) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        (item.isImportant === 1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("td", null, [
                                _createVNode(_component_router_link, {
                                  to: "#",
                                  class: "notice",
                                  onClick: ($event: any) => ($setup.moveDetail(item.idx))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_10,
                                    _createTextVNode(" " + _toDisplayString(item.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _createElementVNode("td", _hoisted_11, _toDisplayString(item.updateDate !== null ?
                                            $setup.formatDate(item.updateDate) :
                                            $setup.formatDate(item.createDate)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    }), 256)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list.data, (item) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        (item.isImportant === 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("td", null, [
                                _createVNode(_component_router_link, {
                                  to: "#",
                                  onClick: ($event: any) => ($setup.moveDetail(item.idx))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", {
                                      innerHTML: item.title
                                    }, null, 8, _hoisted_12)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("span", null, [
                                    _hoisted_14,
                                    _createElementVNode("b", null, _toDisplayString(item.cntRead), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_15,
                                    _createElementVNode("b", null, _toDisplayString(item.cntGood), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_16,
                                    _createElementVNode("b", null, _toDisplayString(item.cntBad), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_17,
                                    _createElementVNode("b", null, _toDisplayString(item.cntComment), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_18, _toDisplayString(item.updateDate !== null ?
                                        $setup.formatDate(item.updateDate) : $setup.formatDate(item.createDate)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    }), 256))
                  ]))
                : _createCommentVNode("", true),
              ($setup.list.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_router_link, {
                to: "#",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/community/write')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("글쓰기")
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_PageBtn, {
              totalLength: $setup.list.length,
              perPage: $setup.list.size,
              "current-page": $setup.list.currentPage,
              onOnPaging: $setup.handlePageChange
            }, null, 8, ["totalLength", "perPage", "current-page", "onOnPaging"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_GnbLayout),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      content: $setup.state.modalContent,
      onClose: $setup.modalClose
    }, null, 8, ["show", "content", "onClose"])
  ], 64))
}